module.exports = __webpack_public_path__ + "static/img/QRCODE.baf512d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/QRCODE.png
// module id = ddvN
// module chunks = 6